import React from 'react';
import { ENV, SITE_URL } from '../../../config/index.js';
import Slider from 'react-slick';

const About = () => {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div className="fuselight-about-container">
      <div className="flex-container">
        <div className="about-content">
          <h1>Welcome to your new collaboration engine.</h1>
          <p>
            For literally thousands of years, brands have looked for the perfect
            partners to sell their stories.
          </p>
          <p>
            From craft beer in ancient Egypt to oils promoted by famous
            gladiators, businesses have always looked for ways to fuse their
            efforts with others to help their brands take off.
          </p>
          <p>
            Until now, these team-ups have, at best, been educated guesses and,
            at worst, hunch-fueled shots in the dark.
          </p>
          <p>
            Introducing{' '}
            <span className="highlight">
              FuseLight<sup>SM</sup>
            </span>
            , a new genAI product that sheds light on these matches by
            predicting the media potential, or “Ignition Thrust,” of proposed
            co-marketing partnerships for people in branding, marketing, social
            media, and entertainment.
          </p>
          <p>
            Get the data-backed evidence and breakthrough ideas you need to
            present, pitch, and produce thought-provoking,
            convention-challenging brand partnerships with massive opportunity.
          </p>
        </div>
        <div className="about-slider">
          <Slider {...sliderSettings}>
            <div>
              <img
                src={
                  ENV === 'development'
                    ? `${SITE_URL}/app/themes/hahn/images/about/About.webp`
                    : `${SITE_URL}/wp-content/themes/hahn/images/about/About.webp`
                }
                alt="FuseLight About"
              />
            </div>
            <div>
              <img
                src={
                  ENV === 'development'
                    ? `${SITE_URL}/app/themes/hahn/images/about/Texas_Realtors_Mythbusters.webp`
                    : `${SITE_URL}/wp-content/themes/hahn/images/about/Texas_Realtors_Mythbusters.webp`
                }
                alt="FuseLight Texas Realtors Mythbusters"
              />
            </div>
            <div>
              <img
                src={
                  ENV === 'development'
                    ? `${SITE_URL}/app/themes/hahn/images/about/Taco_Bell_Whataburger.webp`
                    : `${SITE_URL}/wp-content/themes/hahn/images/about/Taco_Bell_Whataburger.webp`
                }
                alt="FuseLight Taco Bell Whataburger"
              />
            </div>
            <div>
              <img
                src={
                  ENV === 'development'
                    ? `${SITE_URL}/app/themes/hahn/images/about/Budweiser_Corona.webp`
                    : `${SITE_URL}/wp-content/themes/hahn/images/about/Budweiser_Corona.webp`
                }
                alt="FuseLight Budweiser Corona"
              />
            </div>
          </Slider>
        </div>
      </div>
      <div className="button-row">
        <a href="/app/" className="btn btn--secondary-outline">
          Find your match, have a blast
        </a>
      </div>
    </div>
  );
};

export default About;
